export const DIALOG_STYLE = {
  maxWidth: "56.25rem",
  minHeight: "41.5625rem",
};
